import { get, merge, omit } from "lodash";
import * as Base from "./social.account";
export function getAccount(account) {
  const obj = Base.getAccount(account, "instagram");
  const profilePicture = get(account, "profilePicture", "");
  const screenName = obj.screenName || account.userName || account.label;
  const type = get(account, "accountType", null);
  return merge(omit(obj, "screenName"), {
    followers: get(account, "followers", 0),
    id: obj.id || "instagram_" + screenName,
    screenName: undefined,
    label: screenName,
    picture: obj.picture || profilePicture,
    smallPicture: obj.smallPicture || profilePicture,
    bigPicture: obj.bigPicture || profilePicture,
    query: "(origin.platform:instagram AND author:@" + screenName + ")",
    url: screenName ? "http://instagram.com/" + screenName : "",
    gender: get(account, "gender", null),
    type: type !== "undetected" ? type : null,
    "statuses-count": get(account, "statuses-count", 0),
    "followings-count": get(account, "followings-count", 0),
  });
}
